export const draftsFeedbackStatsObjective = [
    { name: "Nome do aluno", value: "userName", completeValue: "completeUserName", filter: false },
    { name: "Email", value: "userEmail", completeValue: "completeUserEmail", filter: false },
    { name: "Mensagem", value: "feedbackText", completeValue: "completeFeedbackText", filter: false },
  ];